/**
 *
 * @Pattern https://mgechev.github.io/angularjs-in-patterns/#facade
 */

export default function Bookings(BookingService, BookingJar) {
    var fn = this;

    /**
     * Vars - Glue external and internal modules
     */
    fn.bookingPeriods = BookingJar.bookingPeriods;

    fn.activity = BookingJar.activity;
    fn.location = BookingJar.location;

    /**
     * API v3
     */

    fn.get = (id) => {
        return BookingService.get(id);
    };

    fn.getByUid = (uid) => {
        return BookingService.getByUid(uid);
    };

    fn.update = (id, updateBookingModel) => {
        return BookingService.update(id, updateBookingModel);
    };

    fn.cancelBooking = (id) => {
        return BookingService.cancelBooking(id);
    };

    fn.getBookingPeriods = (id) => {
        return BookingService.getBookingPeriods(id);
    };

    fn.createBookingId = (id) => {
        return BookingService.createBookingId(id);
    };

    fn.createBookingPeriod = (period, bookingId, activityId, user, isFixed) => {
        return BookingService.createBookingPeriod(
            period,
            bookingId,
            activityId,
            user,
            isFixed
        );
    };

    fn.createBookingPeriodLegacy = (
        period,
        bookingId,
        activity,
        user,
        bookingTypeId
    ) => {
        return BookingService.createBookingPeriodLegacy(
            period,
            bookingId,
            activity,
            user,
            bookingTypeId
        );
    };

    fn.updateBookingPeriod = (bp) => {
        return BookingService.updateBookingPeriod(bp);
    };

    fn.deleteBookingPeriod = (bp) => {
        return BookingService.deleteBookingPeriod(bp);
    };

    fn.completeBooking = (id) => {
        return BookingService.completeBooking(id);
    };

    fn.verify = (id) => {
        return BookingService.verify(id);
    };

    /**
     * Legacy API
     */
    fn.GetOrderOverview = () => {
        return BookingService.GetOrderOverview();
    };

    fn.cancelBookings = () => {
        return BookingService.cancelBookings();
    };

    return fn;
}
